"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardGroup = void 0;
var react_1 = __importDefault(require("react"));
var design_system_layouts_1 = require("@contrast-security-inc/design-system-layouts");
var css_1 = require("@emotion/css");
var cardGroupCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n"])));
var determineCardRole = function (type) {
    switch (type) {
        case 'selections':
            return 'radio';
        case 'buttons':
            return 'button';
        default:
            return 'link';
    }
};
var CardGroup = function (_a) {
    var children = _a.children, className = _a.className, testId = _a.testId, _b = _a.type, type = _b === void 0 ? 'links' : _b, _c = _a.spacing, spacing = _c === void 0 ? '24px' : _c, excludeBackground = _a.excludeBackground, size = _a.size, minHeight = _a.minHeight, minWidth = _a.minWidth, maxWidth = _a.maxWidth, rest = __rest(_a, ["children", "className", "testId", "type", "spacing", "excludeBackground", "size", "minHeight", "minWidth", "maxWidth"]);
    return (react_1.default.createElement(design_system_layouts_1.Stack, __assign({ className: (0, css_1.cx)('ds-card-group', cardGroupCss, className), role: type === 'selections' ? 'radiogroup' : undefined, spacing: spacing, testId: testId }, rest), react_1.default.Children.map(children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                role: determineCardRole(type),
                excludeBackground: excludeBackground,
                size: size,
                minHeight: minHeight,
                minWidth: minWidth,
                maxWidth: maxWidth,
            });
        }
        return child;
    })));
};
exports.CardGroup = CardGroup;
var templateObject_1;
